module.exports = __webpack_public_path__ + "img/logo3.1e7fef2a.png";